import { Screen } from "./screens";

export default Screen;
